import type { BffApiClient } from "@/app/api-client"

export function getBlogSpotlightQueryParams(apiClient: BffApiClient) {
  return {
    queryKey: ["blog", "spotlight"],
    queryFn: async () => {
      const response = await apiClient.api.blog.spotlight.$get(
        {},
        { init: { next: { revalidate: 60 * 3 } } },
      )

      if (!response.ok) throw await response.json()

      const result = response.json()

      return result
    },
  }
}
